import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      theme="dark"
      position="bottom-right"
      offset={16}
      toastOptions={{
        classNames: {
          toast:
            "!bg-neutral-900 !text-neutral-100 !border !border-neutral-800 !shadow-md !rounded-md",
          title: "!text-sm !font-medium",
          description: "!text-xs !text-neutral-400",
          success: "!border-success-border",
          error: "!border-danger-border",
        },
      }}
    />
  );
}

export { toast } from "sonner";
